import { WidgetSpinner } from '../../Spinner/Spinner'
import { RadioGroup } from '../../Form'

import { FilterTypeRadioProps } from '../types'

export const RadioFilterContent = (props: FilterTypeRadioProps) => {
    const { isLoading, name, value, onChange, renderLabel } = props

    if (isLoading) {
        return (
            <div className="flex min-h-filterContentMinHeight place-items-center">
                <WidgetSpinner />
            </div>
        )
    }

    const passedProps = {
        ...props.config,
        value,
        onChange,
        name,
        renderLabel,
    }

    return (
        <RadioGroup
            {...passedProps}
            wrapperClassname="space-y-1"
            itemWrapperClassname="py-2 px-4"
        />
    )
}
